import Swiper from 'swiper';
import $ from 'jquery';

$(document).ready(function() {
    $('.service-titles-block').equalHeights();

    let latestNews = new Swiper('.latest-news-block .swiper-container', {
        speed: 400,
        spaceBetween: 0,
        slidesPerView: 'auto',
        centeredSlides: true,
        loop: true,
        clickable: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
    });

    $('body').on('click', '.services-nav .toggle', function(){
        $(this).toggleClass('open');
        $('.services-nav ul').slideToggle();
    });

    $('body').on('click', '.main-menu-toggle', function(){
        $(this).find('.menu-toggle').toggleClass('active');
        $('.main-navigation').toggleClass('mobile-menu');
        $('body').toggleClass('showmenu');
    });
});

$.fn.equalHeights = function(){
	var max_height = 0;
	$(this).each(function(){
		max_height = Math.max($(this).height(), max_height);
	});
	$(this).each(function(){
		$(this).height(max_height);
	});
};